import type { Localization } from '@/app/components/search/common/Localization.ts';
import { Country } from '@/domainLogic/index.ts';

export const isGermany = (localization: Localization) => localization?.country?.toUpperCase() === Country.DE;
export const isFrance = (localization: Localization) => localization?.country?.toUpperCase() === Country.FR;
